import React, { useEffect, useState } from 'react'
import Header from '../Core/Header'
import { hospital } from '../../Assets/dummyHospital'
import { getAllHospitals } from '../../service/operations/api_methods'

const dummyTests=["Blood Tests","Urine Routine & Microscopy","X-Ray","Ultrasound / Sonography","Stool Routine & Microscopy","Thyroid Tests (TSH, T3, T4)","ECG (Electrocardiogram)","Eye (Retina Test)"];
const dummyDoc=["Dr.S.N Roy","Dr. Vikash Roy","Dr. Aritri Roy"]; 


const ViewHospitals = () => {
    const[list,setList]=useState([])



    const handleFetchHospitals=async()=>{
        try {
            const response=await getAllHospitals()
            console.log("all hospitals",response);
            if(response.status===200){
                let finalList=response.data.data
                setList(finalList.filter(i=>i.alreadyMapped===true))
            }
            
        } catch (error) {
            console.log(error);
            
        }
    }

    useEffect(() => {
      handleFetchHospitals()
    }, [])
    

  return (
    <div style={{height:"100vh",width:"100%",overflow:"hidden"}}>
      <Header/>
      <section style={{marginTop:"80px",height:"calc(100vh - 80px)",background: "linear-gradient(180deg, #555454ff, #ffffffff, #5f5f5fff)",padding:"20px"}}>
        <div style={{fontSize:"24px",fontWeight:"700",textAlign:"center",display:"flex",justifyContent:"space-around",padding:"6px"}}>
            <p style={{color:"white"}}>All Hospitals you are linked with</p>
            <input placeholder='Search hospital by name'
            style={{border:"0.5px solid white",
                borderRadius:"8px",
                fontSize:"16px",padding:"5px",
                backgroundColor:"white"
            }}/>
            </div>
        <div style={{height:"calc(100vh - 100px)",display:"flex",flexWrap:"wrap",width:"100%",overflowY:"auto",overflowX:"hidden"}}>
            {
            list.map((item)=>(
                <div style={{width:"22vw",minHeight:"30vh",maxHeight:"fit-content",borderRadius:"10px",padding:"10px",backgroundColor:"#c5c4c4ff",
                    display:"flex",flexDirection:"column",alignItems:"center",margin:"10px"
                }}>
                    <img src='/Assets/diagonasitic.jpg' style={{height:"150px",width:"85%",borderRadius:"10px"}}/>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"start",width:"90%"}}>
                        <p style={{fontSize:"20px",textAlign:"left",fontWeight:"500"}}>{item.hospital_name}</p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#d65d3eff"}}>Patients:{500}+</span>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#6fa0d8ff"}}>reg:{item.license_number}</span></p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'16px',fontWeight:"700",color:"#a3343aff"}}>{item.address}</span></p>
                           
                        <p style={{fontSize:"14px",fontWeight:"800"}}>Medical Test provided</p>
                        <div style={{width:"100%",display:"flex",alignItems:"center",gap:"10px",flexWrap:"wrap"}}>
                            
                            {
                            dummyTests.map(i=>
                            <p style={{fontSize:"14px",padding:"3px",borderRadius:"8px",backgroundColor:"#041c3bff",color:"white"}}>{i}</p>)
                        }</div>
                            <p style={{fontSize:"14px",fontWeight:"800"}}>Assigned Hospital</p><br/>
                         <div style={{width:"100%",display:"flex",alignItems:"center",gap:"10px",flexWrap:"wrap"}}>
                            
                            {
                            dummyDoc.map(i=>
                            <p style={{fontSize:"14px",padding:"3px",borderRadius:"8px",backgroundColor:"#053d2cff",color:"#fcfcfcff"}}>{i}</p>)
                        }</div>
                     </div>

                    </div>
            ))
            }

        </div>

      </section>
    </div>
  )
}

export default ViewHospitals
